import { render, staticRenderFns } from "./SelectBranch.vue?vue&type=template&id=634db17a&scoped=true"
import script from "./SelectBranch.vue?vue&type=script&lang=js"
export * from "./SelectBranch.vue?vue&type=script&lang=js"
import style0 from "./SelectBranch.vue?vue&type=style&index=0&id=634db17a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634db17a",
  null
  
)

export default component.exports